/**
 * Les mots de la page Paramètres de l'ordinateur (chantier apparence, modification 02, maquette
 * `design/parametres.html`) : ses onglets, et l'onglet Apparence. Le titre de la page est
 * `PARAMETRES`, dans `cadre.ts`.
 */
export const SOUS_TITRE_DES_PARAMETRES = "Ce qui vaut pour toute l'app.";

/** Les onglets, dans l'ordre de la maquette ; seul Apparence est ouvert pour l'instant. */
export const ONGLET_APPARENCE = 'Apparence';
export const ONGLET_COMPTE = 'Compte';
export const ONGLET_IA = 'IA branchée';
export const ONGLET_DONNEES = 'Mes données';
export const ONGLET_AIDE = 'Aide';
/** La marque d'un onglet pas encore ouvert. */
export const ONGLET_PLUS_TARD = 'Plus tard';

/** Le style : l'allure de tout Nextilt. */
export const LE_STYLE = 'Le style';
export const EXPLICATION_DU_STYLE = "L'allure de tout Nextilt.";
export const AMBIANCE = 'Ambiance';
export const AMBIANCE_CARNET = 'Carnet papier';
export const AMBIANCE_CLAIR = 'Clair';
export const AMBIANCE_SOMBRE = 'Sombre';
export const ECRITURE_A_LA_MAIN = 'Écriture à la main';
export const RELIEF_ET_OMBRES = 'Relief et ombres';
export const RELIEF_DOUX = 'Doux';
export const RELIEF_MARQUE = 'Marqué';
export const GRAIN_DU_PAPIER = 'Grain du papier';
/** Après une bulle écrite dans la barre « + Bulle » (chantier modes-de-la-carte, modification 04). */
export const APRES_UNE_BULLE_ECRITE = 'Après une bulle écrite';
export const ECRIRE_LA_SUIVANTE = 'Écrire la suivante';
export const OUVRIR_SA_FICHE = 'Ouvrir sa fiche';

/**
 * Ce qu'un projet neuf reçoit par défaut (maquette du carnet `parametres.html`) : la forme des
 * bulles, à part de l'ambiance (décision 2 d'Igor du 2026-10-19 ; chaque projet a la sienne depuis
 * le chantier habit-du-projet, ticket 03), le type et le papier de ses fiches (chantier
 * types-de-fiche, modification 06).
 */
export const PAR_DEFAUT_UN_PROJET_NEUF = 'Par défaut, un projet neuf';
export const FORME_DES_BULLES = 'Forme des bulles';
export const EXPLICATION_DU_PROJET_NEUF = 'Chaque projet peut ensuite changer, dans son Habit.';
export const FORME_GALET = 'Galet';
export const FORME_RECTANGLE = 'Rectangle';

/** L'aperçu : ce que donnent les réglages. */
export const APERCU = 'Aperçu';
export const EXPLICATION_DE_L_APERCU = 'Ce que donnent tes réglages.';
export const BULLE_DE_L_APERCU = 'Choisir le carrelage';
